import { defineStore, storeToRefs } from 'pinia';
import {
  ref, watch, computed,
} from 'vue';
import { useStore } from 'vuex';

export const useEditorTaskStore = defineStore('editorTask', () => {
  const submitType = ref('submit-all-annotations');
  const imageFilters = ref(null);
  const activeImageIndex = ref(-1);
  const currentTaskImage = ref(null);
  const pendingTaskImages = ref([]);
  const isTaskComplete = ref(false);
  const reviewSettings = ref(null);
  const remainingImagesCount = ref(0);
  const totalImagesCount = ref(0);
  const auditorType = ref('image');
  const isFetchingNewImage = ref(false);
  const store = useStore();

  function $reset() {
    submitType.value = 'submit-all-annotations';
    imageFilters.value = null;
    activeImageIndex.value = -1;
    currentTaskImage.value = null;
    pendingTaskImages.value = [];
    isTaskComplete.value = false;
    reviewSettings.value = null;
    remainingImagesCount.value = 0;
    totalImagesCount.value = 0;
    auditorType.value = 'image';
    isFetchingNewImage.value = false;
  }



  const sourceDatasetId = computed(() => reviewSettings.value?.reviewTask?.dataset_id);

  const sourceDataset = computed(() => {
    const datasets = store.state.datasets.datasetList;
    const dataset_id = sourceDatasetId.value;
    const dataset = datasets.find((d) => d.id === dataset_id);
    return dataset || null;
  });

  const sourceAnnotationSet = computed(() => {

    if (reviewSettings.value==null || sourceDataset.value==null) return null;

    const source_annotation_set_id = reviewSettings.value?.reviewTask?.source_annotation_set_id;
    const sourceAnnotationSet = sourceDataset.value?.annotation_sets.find((as) => as.id === source_annotation_set_id);
    if (sourceAnnotationSet) {
      return sourceAnnotationSet;
    }
    return null;
  });

  const hasSourceAnnotationSet = computed(() => Boolean(sourceAnnotationSet.value));

  const destinationAnnotationSet = computed(() => {
    const dest_annotation_set_id = reviewSettings.value?.reviewTask?.dest_annotation_set_id;
    return sourceDataset.value?.annotation_sets.find((as) => as.id === dest_annotation_set_id);
  });

  const groups = computed(() => {
    if (sourceDataset.value?.groups) {
      return sourceDataset.value.groups;
    }
    return [];
  });

  const hasReviewTask = computed(() => !!reviewSettings.value?.reviewTask?.id);

  const isAuditMode = computed(() => hasSourceAnnotationSet.value && (sourceAnnotationSet.value?.id !== destinationAnnotationSet.value?.id));

  return {
    submitType,
    imageFilters,
    activeImageIndex,
    currentTaskImage,
    pendingTaskImages,
    isTaskComplete,
    reviewSettings,
    remainingImagesCount,
    totalImagesCount,
    auditorType,
    isFetchingNewImage,
    // computed
    sourceDatasetId,
    sourceDataset,
    sourceAnnotationSet,
    hasSourceAnnotationSet,
    destinationAnnotationSet,
    groups,
    hasReviewTask,
    isAuditMode,
    $reset,
  };
});
